import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import NewsCard from '@/components/feature/NewsCard';
import SectionHeading from '@/components/feature/SectionHeading';

interface TodayPicksProps {
  articles: NewsArticle[];
}

export default function TodayPicks({ articles }: TodayPicksProps) {
  return (
    <section>
      <SectionHeading
        title="今日推荐"
        subtitle="为你精选最新发布的资讯内容"
        icon="ri-thumb-up-line"
        action={
          <Link
            to="/category/news"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-secondary-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-s-line" />
          </Link>
        }
      />
      {articles.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 rounded-lg border border-dashed border-background-300 bg-background-100 text-foreground-500">
          <i className="ri-inbox-line text-3xl mb-2" />
          <p className="text-sm">暂无相关内容</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <NewsCard key={article.id} article={article} />
          ))}
        </div>
      )}
    </section>
  );
}